import { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  DropdownToggle,
  DropdownMenu,
  Nav,
  Col,
  Row,
  Button,
  NavItem,
  NavLink,
  UncontrolledButtonDropdown,
} from 'reactstrap';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import 'react-toastify/dist/ReactToastify.css';

import city3 from '../../../assets/utils/images/dropdown-header/city3.jpg';
import avatar1 from '../../../assets/utils/images/avatars/1.jpg';
import { clearStoredAuth, getStoredUser } from '../../../auth/session';

const getRoleLabel = (role) => {
  if (role === 'master') {
    return 'Master Administrator';
  }

  if (role === 'admin') {
    return 'Administrator';
  }

  return 'System User';
};

const UserBox = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(() => getStoredUser());

  useEffect(() => {
    const syncAuth = () => setUser(getStoredUser());

    window.addEventListener('authchange', syncAuth);
    return () => window.removeEventListener('authchange', syncAuth);
  }, []);

  const handleLogout = () => {
    clearStoredAuth();
    navigate('/login', { replace: true });
  };

  return (
    <Fragment>
      <div className="header-btn-lg pe-0">
        <div className="widget-content p-0">
          <div className="widget-content-wrapper">
            <div className="widget-content-left">
              <UncontrolledButtonDropdown>
                <DropdownToggle color="link" className="p-0">
                  <img width={42} className="rounded-circle" src={avatar1} alt="" />
                  <FontAwesomeIcon className="ms-2 opacity-8" icon={faAngleDown} />
                </DropdownToggle>
                <DropdownMenu className="rm-pointers dropdown-menu-lg">
                  <div className="dropdown-menu-header">
                    <div className="dropdown-menu-header-inner bg-info">
                      <div
                        className="menu-header-image opacity-2"
                        style={{
                          backgroundImage: `url(${city3})`,
                        }}
                      />
                      <div className="menu-header-content text-start">
                        <div className="widget-content p-0">
                          <div className="widget-content-wrapper">
                            <div className="widget-content-left me-3">
                              <img width={42} className="rounded-circle" src={avatar1} alt="" />
                            </div>
                            <div className="widget-content-left">
                              <div className="widget-heading">
                                {user?.fullName || 'Authenticated user'}
                              </div>
                              <div className="widget-subheading opacity-8">
                                {user?.email || 'No active session'}
                              </div>
                            </div>
                            <div className="widget-content-right me-2">
                              <Button
                                className="btn-pill btn-shadow btn-shine"
                                color="focus"
                                onClick={handleLogout}
                              >
                                Logout
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="scroll-area-xs" style={{ height: '150px' }}>
                    <PerfectScrollbar>
                      <Nav vertical>
                        <NavItem className="nav-item-header">Session</NavItem>
                        <NavItem>
                          <NavLink href="#" onClick={(event) => event.preventDefault()}>
                            Current profile
                            <div className="ms-auto badge rounded-pill bg-info">
                              {user?.role || 'guest'}
                            </div>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink href="#" onClick={(event) => event.preventDefault()}>
                            {user?.email || 'No email'}
                          </NavLink>
                        </NavItem>
                        <NavItem className="nav-item-header">Account</NavItem>
                        <NavItem>
                          <NavLink href="#" onClick={(event) => event.preventDefault()}>
                            {getRoleLabel(user?.role)}
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink href="#" onClick={(event) => event.preventDefault()}>
                            General access enabled
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </PerfectScrollbar>
                  </div>
                  <Nav vertical>
                    <NavItem className="nav-item-divider mb-0" />
                  </Nav>
                  <div className="grid-menu grid-menu-2col">
                    <Row className="g-0">
                      <Col sm="6">
                        <Button
                          className="btn-icon-vertical btn-transition btn-transition-alt pt-2 pb-2"
                          outline
                          color="warning"
                          onClick={() => navigate('/dashboards/crm')}
                        >
                          <i className="pe-7s-rocket icon-gradient bg-amy-crisp btn-icon-wrapper mb-2">
                            {' '}
                          </i>
                          Dashboard
                        </Button>
                      </Col>
                      <Col sm="6">
                        <Button
                          className="btn-icon-vertical btn-transition btn-transition-alt pt-2 pb-2"
                          outline
                          color="danger"
                          onClick={handleLogout}
                        >
                          <i className="pe-7s-power icon-gradient bg-love-kiss btn-icon-wrapper mb-2">
                            {' '}
                          </i>
                          <b>Sign out</b>
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </DropdownMenu>
              </UncontrolledButtonDropdown>
            </div>
            <div className="widget-content-left ms-3 header-user-info">
              <div className="widget-heading">{user?.fullName || 'User'}</div>
              <div className="widget-subheading">{getRoleLabel(user?.role)}</div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default UserBox;
